import { DisplayMarket, Percent, PERCENT_ZERO } from '@silo/types';
import { MarketCards as BaseMarketCards } from '@silo/ui';
import NextLink from 'next/link';
import { TokenLogo } from './token-logo';
import { forwardRef } from 'react';
import { getIsRevenueMarket } from '@silo/utils';

interface MarketCardsProps {
  markets: DisplayMarket[];
  revenueApr: Percent;
}

const { marketLogoSize, tokenLogoSize } = BaseMarketCards;

export function MarketCards({ markets, revenueApr }: MarketCardsProps): JSX.Element {
  return (
    <>
      <BaseMarketCards.Container>
        {markets.map((market) => {
          const { protocolKey, marketAddress } = market;
          const effectiveRevenueApr = getIsRevenueMarket(protocolKey, marketAddress) ? revenueApr : PERCENT_ZERO;

          return (
            <NextLink key={market.marketAddress} href={`/silo/${market.marketAddress}`}>
              <BaseMarketCards.Card
                market={market}
                marketLogo={<TokenLogo size={marketLogoSize} />}
                tokenLogo={<TokenLogo size={tokenLogoSize} />}
                revenueApr={effectiveRevenueApr}
              />
            </NextLink>
          );
        })}
      </BaseMarketCards.Container>
    </>
  );
}

interface PulseMarketCardsProps {
  pageSize: number;
}

export const PulseMarketCards = forwardRef<HTMLDivElement, PulseMarketCardsProps>(({ pageSize }, ref) => {
  return (
    <div ref={ref} className={BaseMarketCards.container({ className: 'mt-2.5 animate-pulse' })}>
      {[...Array(pageSize)].map(() => (
        <BaseMarketCards.PulseCard />
      ))}
    </div>
  );
});
